<template>
    <div class="field is-horizontal mileage">
        <div class="field-label is-normal">
            <label class="label">
                <i class="fas fa-tachometer-alt"></i>
                Mileage</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    <div class="select is-fullwidth">
                        <select v-model="minKm">
                            <option :value="null" disabled>Any</option>
                            <option v-for="km in kms" :value="km">{{ km | formatNumber }}</option>
                        </select>
                        <div class="advance-dropdown"><i class="fa fa-angle-down"></i></div>
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <div class="select is-fullwidth">
                        <select v-model="maxKm">
                            <option :value="null" disabled>Any</option>
                            <option v-for="km in kms" :value="km">{{ km | formatNumber }}</option>
                        </select>
                        <div class="advance-dropdown"><i class="fa fa-angle-down"></i></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {

        },
        data() {
            return {
                kms: [],
            }
        },
        computed: {
            minKm: {
                get: function () {
                    return this.$store.getters.getQueryKmMin
                },
                set: function (value) {
                    this.$store.dispatch('addNewKmRangeMinValue', value)
                }
            },
            maxKm: {
                get: function () {
                    return this.$store.getters.getQueryKmMax
                },
                set: function (value) {
                    this.$store.dispatch('addNewKmRangeMaxValue', value)
                }
            }
        },
        methods: {
            generateKmsArrays() {
                let minOffset = 0, maxOffset = 30;
                let thisKms = 30;
                let kms = [];

                for (let i = minOffset; i <= maxOffset; i++) {
                    let newKms = (thisKms - i) * 10000;
                    kms.push(newKms);
                }

                this.kms = kms
            }
        },
        created() {
            this.generateKmsArrays()
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Auctions/Advance/Inputs/Mileage.vue